import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgSettingsSpecialOffer({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        d="M13.93 7.7c.07 0 .14.07.14.14v5.96c0 .42-.28.7-.7.7H8.98a.3.3 0 01-.28-.28V7.98a.3.3 0 01.28-.28zm-6.91 0a.3.3 0 01.28.28v6.24a.3.3 0 01-.28.28H2.63c-.42 0-.7-.28-.7-.7V7.84c0-.07.07-.14.14-.14zM10.8.5c1.19 0 2.1.91 2.1 2.1 0 .56-.21 1.05-.56 1.4h1.96c.42 0 .7.28.7.7v1.96c0 .07-.07.14-.14.14H8.98a.3.3 0 01-.28-.28V4.28A.3.3 0 008.42 4h-.84a.3.3 0 00-.28.28v2.24a.3.3 0 01-.28.28H1.14A.15.15 0 011 6.66V4.7c0-.42.28-.7.7-.7h1.96a1.95 1.95 0 01-.56-1.4c0-1.19.91-2.1 2.1-2.1.7 0 1.96.63 2.8 1.47C8.84 1.13 10.1.5 10.8.5zM5.2 1.9c-.42 0-.7.28-.7.7 0 .42.28.7.7.7h2.38A6.46 6.46 0 005.2 1.9zm5.6 0c-.42 0-1.96.91-2.38 1.4h2.38c.42 0 .7-.28.7-.7 0-.42-.28-.7-.7-.7z"
        fillRule="evenodd"
      />
    </svg>
  );
}

SvgSettingsSpecialOffer.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgSettingsSpecialOffer.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => (
  <SvgSettingsSpecialOffer svgRef={ref} {...props} />
));
export default ForwardRef;
